import isEqual from 'lodash/isEqual'
import { DependencyList, EffectCallback, useEffect, useRef } from 'react'

function useDeepCompareMemoize(value: DependencyList) {
  const ref = useRef<DependencyList>()
  if (!isEqual(value, ref.current)) {
    ref.current = value
  }
  return ref.current
}

/**
 * Use effect but with dependecies compared by [lodash/isEqual](https://lodash.com/docs/4.17.20#isEqual)
 */
function useDeepCompareEffect(callback: EffectCallback, dependencies: DependencyList) {
  useEffect(callback, useDeepCompareMemoize(dependencies))
}

export default useDeepCompareEffect
